<template>
  <div>
    <FaqItem
      v-for="(item, index) in items"
      :key="`faq-item-${index}`"
      v-bind="item"
      :show="show === index"
      @toggle="faqToggle(index)"
    ></FaqItem>
  </div>
</template>

<script>
import {
  defineComponent,
  nextTick,
  onMounted,
  ref,
} from '@nuxtjs/composition-api';
import debounce from 'lodash/debounce';
import FaqItem from './FaqItem.vue';

export default defineComponent({
  name: 'FaqGrid',
  components: { FaqItem },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const show = ref(null);

    const toggle = (index) => {
      if (index === show.value) {
        show.value = null;
      } else {
        show.value = index;
      }
    };

    onMounted(() => {
      nextTick(() => (show.value = 0));
    });

    return {
      show,
      faqToggle: debounce(toggle, 200),
    };
  },
});
</script>
